import React from 'react';
import { HeroSection } from '../components/HeroSection';
import { AboutSection } from '../components/AboutSection';
import { ContactCTA } from '../components/ContactCTA';
import { ServicesSection } from '../components/ServicesSection';
import { TestimonialsSection } from '../components/TestimonialsSection';
import { EmploymentSection } from '../components/EmploymentSection';
export function HomePage() {
  return <main data-id="element-652">
      <HeroSection data-id="element-653" />
      <AboutSection data-id="element-654" />
      <ContactCTA data-id="element-655" />
      <ServicesSection data-id="element-656" />
      <TestimonialsSection data-id="element-657" />
      <EmploymentSection data-id="element-658" />
    </main>;
}